<h2 mat-dialog-title style="display: block">Add New Production Job</h2>
<mat-dialog-content>
  <div class="input-container">
    <mat-form-field style="width:50%; margin-top: 10px;" appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput [(ngModel)]="jobTitle" placeholder="Name">
    </mat-form-field>
  </div>
  <lex-bates-range-select [productionJobs]="productionJobs" [isCreateMode]="true"
    (selectedRangeEvent)="selectedRangeEvent($event)"
    style="display: block; width: 100%; height: 300px;  overflow: auto;"></lex-bates-range-select>
</mat-dialog-content>
<div class="actions-container">
  <mat-dialog-actions>
    <button mat-raised-button color="primary" id="create-new-production" (click)="startNewPrefix()">Create New
      Production</button>
    <button mat-raised-button id="cancel-create-new-production" (click)="closeDialog()">Cancel</button>
  </mat-dialog-actions>
</div>